import { format } from 'date-fns';
import { type ReactElement } from 'react';
import { TimeElement } from '../../TimeElement/TimeElement';
import sv from '../../Util/customDateFnsSwedish';
import type { ClusteredMarkerLayerOptions } from '../Layers/Layers.types';
import { type ParkingSthlmProperties } from '../Sources/ParkingsSthlm/ParkingBase';
import PopupTemplateWrapper from './PopupTemplateWrapper';

export default function ParkingSthlm(properties: ParkingSthlmProperties, layerOptions: ClusteredMarkerLayerOptions): ReactElement {
    return (
        <PopupTemplateWrapper iconId={properties.iconId ?? layerOptions.defaultIconId} title={layerOptions.name}>
            <div className="">
                <h3>{properties.streetName}</h3>
                <table>
                    <tbody>
                        {properties.district && (
                            <tr>
                                <td>Stadsdel:</td>
                                <td>{properties.district}</td>
                            </tr>
                        )}
                        {properties.address && (
                            <tr>
                                <td>Adress:</td>
                                <td>{properties.address}</td>
                            </tr>
                        )}
                        {properties.timeLimit && (
                            <tr>
                                <td>Max parkeringstid:</td>
                                <td>
                                    {properties.timeLimit}
                                    {properties.timeLimitDescription && `. ${properties.timeLimitDescription}`}
                                </td>
                            </tr>
                        )}
                        {properties.vehicleLength && (
                            <tr>
                                <td>Längd:</td>
                                <td>{properties.vehicleLength} m</td>
                            </tr>
                        )}
                        {properties.parkingCost && (
                            <tr>
                                <td>Pris:</td>
                                <td>{properties.parkingCost}</td>
                            </tr>
                        )}
                        {properties.extraInfo && (
                            <tr>
                                <td>Övrig information:</td>
                                <td>{properties.extraInfo}</td>
                            </tr>
                        )}
                        {properties.parkingBan && (
                            <tr>
                                <td>Parkeringsförbud:</td>
                                <td>{properties.parkingBan}</td>
                            </tr>
                        )}
                        {!!properties.startMonth && !!properties.startDay && !!properties.endMonth && !!properties.endDay && (
                            <tr>
                                <td>Tillåten parkering:</td>
                                <td>
                                    Från{' '}
                                    <TimeElement dateTimeString={`${properties.startMonth - 1}-${properties.startDay}`}>
                                        {format(new Date(2000, properties.startMonth - 1, properties.startDay), 'dd MMMM', {
                                            locale: sv,
                                        })}
                                    </TimeElement>
                                    till{' '}
                                    <TimeElement dateTimeString={`${properties.endMonth - 1}-${properties.endDay}`}>
                                        {format(new Date(2000, properties.endMonth - 1, properties.endDay), 'dd MMMM', {
                                            locale: sv,
                                        })}
                                    </TimeElement>
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </PopupTemplateWrapper>
    );
}
